import { DashboardWrapper } from "components";
import SettingsView from "./SettingsView";

export const SettingsContainer = () => {
  return (
    <DashboardWrapper>
      <SettingsView />
    </DashboardWrapper>
  );
};
